import axios from "axios";
import { API_URL } from "../shared/constant";
import AuthUser from "./AuthUser";
export default function InquiryModel() {
  //const navigate = useNavigate();
  const { getToken } = AuthUser();

  const httpInquiry = axios.create({
    baseURL: API_URL,
    headers: {
      "Content-type": "application/json",
      "Bearer-Token": getToken(),
    },
  });
  return { httpInquiry };
}
